import { gql } from "~/__generated__"

export const SELF_SERVE_SIGN_UP_MUTATION = gql(`
  mutation UserSelfSignup($input: UserSelfSignupInput!) {
    userSelfSignup(input: $input) {
      user {
        ...CurrentUser
      }
    }
  }
`)
